export default {
  SUPER_ADMIN: '/',
  GROUP_ADMIN: '/',
  COMPANY_ADMIN: '/',
  COMPANY_USER: '/'
}



// WEBPACK FOOTER //
// ./src/router/default.js